.panel {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-4);
  border-top: 1px solid var(--tuna-border-default);
}

.correct {
  color: var(--tuna-feedback-success);
  margin: 0;
}

.incorrect {
  color: var(--tuna-feedback-error);
  margin: 0;
}

.actions {
  display: flex;
  gap: var(--tuna-spacing-2);
}
